<form [formGroup]="entityAffiliationForm" (ngSubmit)="clickSubmit()" (keydown.enter)="$event.preventDefault()">
  <div class="cw-horizontalline"></div>
  <phscw-input-select
    formControlName="other_entity_type"
    [editMode]="editMode"
    label="{{ 'Entitätstyp' // person etc 'GENERAL.TYPE' | translate }}"
    name="other_entity_type"
    inputId="other_entity_type"
    [required]="true"
    listentries="entityAffilitionRelationshipEntityType"
    [myValue]="otherEntityType"
  (selectionChanged)="updateAutocompleteProperties($event)"></phscw-input-select>

  <phscw-input-select
    formControlName="relationship_direction"
    [editMode]="editMode"
    label="{{ 'Verbindungsart' // 'GENERAL.TYPE' | translate }}"
    name="relationship_direction"
    inputId="relationship_direction"
    [required]="true"
    [selectData]="directions"
  [myValue]="entityAffiliationForm.get('relationship_direction').value"></phscw-input-select>

  <!-- Autocomplete Suche - nur anzeigen, wenn Entitätstyp vorhanden -->
  @if (otherEntityType) {
    <phscw-input-autocomplete
      formControlName="other_entity"
      [editMode]="editMode"
      [label]="autocompleteLabel"
      name="other_entity_name"
      inputId="other_entity_name"
      [required]="true"
      [backendLink]="autocompleteLink"
      [returnLabel]="true">
    </phscw-input-autocomplete>
  }

  <!-- Typ der Verknüpfung -->
  <phscw-input-select
    formControlName="relationship_type"
    [editMode]="editMode"
    label="{{ 'GENERAL.TYPE' | translate }}"
    name="relationship_type"
    inputId="relationship_type"
    [required]="true"
    [myValue]="entityAffiliationForm.get('relationship_type').value"
  [selectData]="relationshipTypeOptions"></phscw-input-select>

  <div class="cw-horizontalline"></div>
  @if (editMode) {
    <div class="cw-button-wrapper">
      <button mat-raised-button color="accent" type="submit" [disabled]="!entityAffiliationForm.valid || saving">
        {{ 'GENERAL.SAVE' | translate }}<span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
      </button>
      <button mat-raised-button color="primary" type="button" (click)="clickCancel()">
        {{ 'GENERAL.CANCEL' | translate }}
      </button>
    </div>
  }
</form>
